import { render, staticRenderFns } from "./CartProduct.vue?vue&type=template&id=63c1f3ed&scoped=true&"
import script from "./CartProduct.vue?vue&type=script&lang=js&"
export * from "./CartProduct.vue?vue&type=script&lang=js&"
import style0 from "./CartProduct.vue?vue&type=style&index=0&id=63c1f3ed&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c1f3ed",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AirtableImage: require('/opt/build/repo/components/AirtableImage.vue').default,ITrash: require('/opt/build/repo/components/svg/Trash.vue').default})
